// src/pages/Welcome/Welcome.jsx
import React from 'react';
import { auth } from '../../services/firebase';
import { welcomeStyles } from './styles';
import { useWelcomeData } from './useWelcomeData';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import MarketplaceSection from './MarketplaceSection';
import StatsSection from './StatsSection';
import TrustSection from './TrustSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';

const Welcome = () => {
  const user = auth.currentUser;
  
  const {
    filters,
    setFilters,
    search,
    setSearch,
    sort,
    setSort,
    filteredListings,
    loading
  } = useWelcomeData();

  return (
    <div style={welcomeStyles.container}>
      <HeroSection user={user} />
      <FeaturesSection />
      <StatsSection />
      <MarketplaceSection
        loading={loading}
        filteredListings={filteredListings}
        filters={filters}
        setFilters={setFilters}
        search={search}
        setSearch={setSearch}
        sort={sort}
        setSort={setSort}
      />
      <TrustSection />
      <TestimonialsSection />
      <CTASection user={user} />
    </div>
  );
};

export default Welcome;